import angular from 'angular';

import databaseService from '../../services/database.service.js';

import databasesListController from './databasesList.controller.js';
import databasesListItemController from './databasesListItem.controller.js';
import databaseCreateController from './databaseCreate.controller.js';
import databaseCreateModalController from './databaseCreateModal.controller.js';
import databaseDeleteController from './databaseDelete.controller.js';
import databaseDeleteModalController from './databaseDeleteModal.controller.js';
import databaseXCommandController from './databaseXCommand.controller.js';
import databaseXCommandModalController from './databaseXCommandModal.controller.js';
import databaseGetDocumentController from './databaseGetDocument.controller.js';
import databaseEnableController from './databaseEnable.controller.js';

export default angular.module('components.database', [
    databaseService
])
    .component('databasesList', {
        template: require('./databasesList.pug')(),
        bindings: {
            repository: '<'
        },
        controller: databasesListController
    })
    .component('databasesListItem', {
        template: require('./databasesListItem.pug')(),
        bindings: {
            item: '<'
        },
        controller: databasesListItemController
    })
    .component('databaseCreate', {
        template: require('./databaseCreate.pug')(),
        bindings: {
            text: '@',
            repository: '<',
            onDone: '&'
        },
        controller: databaseCreateController
    })
    .component('databaseCreateModal', {
        template: require('./databaseCreateModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: databaseCreateModalController
    })
    .component('databaseXCommand', {
        template: require('./databaseXCommand.pug')(),
        bindings: {
            text: '@',
            title: '@',
            command: '@',
            database: '<',
            file: '<',
            disabled: '<',
            onDone: '&'
        },
        controller: databaseXCommandController
    })
    .component('databaseXCommandModal', {
        template: require('./databaseXCommandModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: databaseXCommandModalController
    })
    .component('databaseDelete', {
        template: require('./databaseDelete.pug')(),
        bindings: {
            text: '@',
            database: '<',
            onDone: '&'
        },
        controller: databaseDeleteController
    })
    .component('databaseDeleteModal', {
        template: require('./databaseDeleteModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: databaseDeleteModalController
    })
    .component('databaseGetDocument', {
        template: require('./databaseGetDocument.pug')(),
        bindings: {
            database: '<',
            schema: '@',
            docid: '<'
        },
        controller: databaseGetDocumentController
    })
    .component('databaseSize', {
        template: '<span>{{$ctrl.size}}</span>',
        bindings: {
            database: '<'
        },
        controller: ['DatabaseService', function(DatabaseService) {
            var ctrl = this;

            ctrl.size = -1;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    ctrl.database = changes.database.currentValue;
                    getsize();
                }
            }


            ////////

            function getsize() {
                var qs = {
                    id: ctrl.database,
                    command: 'search',
                    query: '@1=_ALLRECORDS @2=103 ""',
                    maximumRecords: 0
                }
                console.log(qs);
                DatabaseService.get(qs).$promise.then(function(response) {
                    if (response.success) {
                        ctrl.size = response.data.numberOfRecords;
                    }
                });
            }
        }]
    })
    .component('databaseEnable', {
        bindings: {
            id: '<',
            done: '&'
        },
        template: require('./databaseEnable.pug')(),
        controller: databaseEnableController
    })
    .name;
